export default __webpack_public_path__ + "bff7fbd6355994c9854b96041c4df3ff.jpg";